import { type Lang, supportedLangs, langLabels } from "@/lib/i18n";
import { Globe } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface LanguageSwitcherProps {
  lang: Lang;
  onChangeLang: (lang: Lang) => void;
}

export function LanguageSwitcher({ lang, onChangeLang }: LanguageSwitcherProps) {
  return (
    <div className="flex items-center gap-2" data-testid="language-switcher">
      <Globe className="w-4 h-4 text-muted-foreground" />
      <Select value={lang} onValueChange={(val) => onChangeLang(val as Lang)}>
        <SelectTrigger
          className="w-[140px] bg-background/60 backdrop-blur-sm border-border/50"
          data-testid="select-language-trigger"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {supportedLangs.map((l) => (
            <SelectItem key={l} value={l} data-testid={`select-language-${l}`}>
              {langLabels[l]}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
